import { fromJS } from 'immutable';

import { SET_LOADING_FLAG, SET_MODULE_SUGGESTIONS, SET_PROJECT } from './constants';

export const initialState = fromJS({
  loading: false,
  project: {},
  module_suggestions: [],
});

function homePageReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_FLAG:
      return state.set('loading', action.loading);
    case SET_PROJECT:
      return state.set('project', fromJS(action.project));
    case SET_MODULE_SUGGESTIONS:
      return state.set('module_suggestions', fromJS(action.modules));
    default:
      return state;
  }
}
export default homePageReducer;
